import * as React from 'react';
import { useLogger } from '@ids/appshell';

function useSurveySparrow(surveySparrowRef: React.RefObject<HTMLElement>, eventHandler: (event: MessageEvent) => void) {
    const logger = useLogger();

    React.useEffect(() => {
        window.addEventListener('message', eventHandler);
        return () => {
            window.removeEventListener('message', eventHandler);
        };
    }, [eventHandler, surveySparrowRef]);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            if (surveySparrowRef.current && !surveySparrowRef.current.querySelector('iframe')) {
                logger.error('Sparrow form did not load after 5 seconds');
            }
        }, 5000);
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [logger, surveySparrowRef]);
}

export default useSurveySparrow;
